<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 10px; line-height: 50px;border-bottom: 1px solid #ddd;">
            异常记录
        </div>
        <div style="padding: 20px;">

            <div>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table
                            :data="tableData"
                            v-loading="loading"
                            :height="th"
                            border
                            style="width: 100%;">
                        <el-table-column
                                prop="url"
                                label="地址" width="200">
                        </el-table-column>

                        <el-table-column
                                prop="param"
                                label="参数" width="300">
                        </el-table-column>

                        <el-table-column
                                prop="message"
                                label="信息" width="1000">
                        </el-table-column>
                        <el-table-column prop="createTime" :formatter="timefilter" width="200" label="日期"></el-table-column>
                        <el-table-column
                                prop="type"
                                label="类型">
                        </el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

    </div>

</template>

<script>
    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    export default {
        name: "Housekeeper",
        data(){
            return{
                loading:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                status: 100,
                showModalAdd:false,
                showModalEdit:false,
                editItem:null,
                th:0,
            }
        },
        created(){
            this.getList();
            this.th = this.$store.state.tableHeight;
        },
        components:{
        },
        watch: {

            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },

        },
        methods:{

            getList(){

                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'Error/List',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    console.log(response.data.data);
                    this.loading = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        console.log(response.data.data.list)
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            timefilter(row, column, cellValue){
                return timefilters(cellValue)
            },
            currentSel:function(selVal){
                this.status = selVal;
            },
            deleteRow(index, rows) {
                rows.splice(index, 1);
            },
            handleEdit(index, row) {
                console.log(index, row);
                this.editItem = row;
                this.$refs.myEdit.init();
                this.showModalEdit = !this.showModalEdit;

            },
            handleDelete(index, row) {
                console.log(index, row);
            },

        }

    }
</script>

<style scoped>

</style>
